"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = exports.EventBus = void 0;
/**
 * A minimal event emitter, as a replacement for RxJS Subject. Any type can be
 * an event. Use this when you want to subscribe to things that happen but don't
 * care about current/previous values. Supports multiple subscriptions to new
 * events. NOT compatible with use-subscription. Awkward name chosen to not conflict
 * with other existing types.
 */
class EventBus {
    _subscriptions = new Set();
    /**
     * Notify all subscribers of an event.
     */
    next(value) {
        for (const subscription of this._subscriptions) {
            subscription(value);
        }
    }
    /**
     * Add a subscription to events. Returns a function that can be used to unsubscribe.
     */
    subscribe(callback) {
        this._subscriptions.add(callback);
        return () => this._subscriptions.delete(callback);
    }
}
exports.EventBus = EventBus;
/**
 * A minimal Observable value, as a replacement for RxJS BehaviorSubject.
 * Supports multiple subscriptions to value changes and getting the last/current value.
 * Compatible with use-subscription: https://github.com/facebook/react/tree/master/packages/use-subscription
 */
class Observable {
    _value;
    _event = new EventBus();
    constructor(initialValue) {
        this._value = initialValue;
    }
    /**
     * Update the value of this observable and notify all subscribers.
     */
    next(value) {
        this._value = value;
        this._event.next(value);
    }
    /**
     * Get the last value that was set for this observable.
     * This needs to be an arrow function so it is bound to the instance since use-subscription uses it that way.
     */
    getCurrentValue = () => this._value;
    /**
     * Add a subscription to value changes. Returns a function that can be used to unsubscribe.
     * The subscription is not called until the value changes - if you want the value at subscription
     * time call getCurrentValue().
     * This needs to be an arrow function so it is bound to the instance since use-subscription uses it that way.
     */
    subscribe = (callback) => this._event.subscribe(callback);
}
exports.Observable = Observable;
//# sourceMappingURL=observable.js.map